import React from "react";
import NbfcLoginContainer from "../../containers/Login/nbfcLoginContainer";

export default function NbfcLoginPage(){
    return (
        <NbfcLoginContainer />
    )
}